module.exports = __webpack_public_path__ + "img/datas-title.ce52fe7e.png";